import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import '@/assets/css/themify-icons.css';
export default class FormWizardOptions{
    public nextButtonText!: string;
    public backButtonText!: string;
    public finishButtonText!: string;
    public stepSize!: string;
    public color!: string;
    public errorColor!: string;
    public shape!: string;
    public startIndex!: Number;
    constructor(public title = String(), public subtitle = String()){
        this.nextButtonText = "Siguiente";
        this.backButtonText = "Anterior";
        this.finishButtonText = "Finalizar";
        this.stepSize = "md";
        this.color = "#7957d5";
        this.errorColor = "hsl(348, 100%, 61%)";
        this.shape = "circle";
        this.startIndex = 0;
    }
}
